import {
    Button,
    Layout,
    Modal,
    MultipleTextField,
    TextField,
    Typography,
    useAlert
} from "matsuri-ui"
import { css } from "@emotion/react"
import { useState } from "react"
import {
    ROUTE_DESCRIPTION_MAX_CHARS,
    TransportationExpense,
    countRouteDescriptionChars,
    displayExpenseDate,
    validateExpenseInput
} from "@/model/transportationExpense"
import { theme } from "@/theme"
import { useTranslation } from "@/hooks/useTranslation"

export const EditExpenseDialog = ({
    expense,
    submitting,
    onSubmit,
    onClose
}: {
    expense: TransportationExpense
    submitting: boolean
    onSubmit: (input: { amount: number; routeDescription: string }) => void
    onClose: () => void
}) => {
    const { t } = useTranslation()
    const { throwAlert } = useAlert()

    const [amountRaw, setAmountRaw] = useState(String(expense.amount))
    const [routeDescription, setRouteDescription] = useState(
        expense.routeDescription
    )

    return (
        <Modal
            open
            backdrop
            header={
                <Typography variant="h3" align="center">
                    {t("申請内容を修正")}
                </Typography>
            }
            body={
                <Layout.Column gap={2}>
                    <Typography align="center">
                        {`${displayExpenseDate(expense.expenseDate)} ${t("の申請")}`}
                    </Typography>

                    <MultipleTextField
                        name="routeDescription"
                        label={t("経路")}
                        value={routeDescription}
                        onChange={value => setRouteDescription(value)}
                        required
                        helperText={({ value }) =>
                            `${countRouteDescriptionChars(value ?? "")}/${ROUTE_DESCRIPTION_MAX_CHARS}`
                        }
                    />

                    <TextField
                        name="amount"
                        label={t("金額（円）")}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={amountRaw}
                        onChange={value => setAmountRaw(value)}
                        required
                    />

                    <Typography
                        variant="caption"
                        css={css`
                            color: ${theme.palette.gray[600]};
                        `}
                    >
                        {t("修正できるのは清掃日の翌日までです")}
                    </Typography>
                </Layout.Column>
            }
            footer={
                <Layout.Row gap={1} nowrap>
                    <Button fullWidth onClick={onClose} disabled={submitting}>
                        {t("キャンセル")}
                    </Button>
                    <Button
                        variant="filled"
                        color="primary"
                        fullWidth
                        disabled={submitting}
                        loading={submitting}
                        onClick={() => {
                            const inputResult = validateExpenseInput(
                                amountRaw,
                                routeDescription
                            )
                            if (!inputResult.ok) {
                                throwAlert(new Error(t(inputResult.message)), {
                                    errorMessage: {
                                        happend: t(inputResult.message)
                                    }
                                })
                                return
                            }

                            onSubmit(inputResult.value)
                        }}
                    >
                        {t("修正する")}
                    </Button>
                </Layout.Row>
            }
        />
    )
}
